(function() {
    'use strict';
    angular
        .module('dialysisApp')
        .factory('MedRoute', MedRoute);

    MedRoute.$inject = ['$resource'];

    function MedRoute ($resource) {
        var resourceUrl =  'api/med-routes/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();
